import { useLocation } from 'react-router';

import { AutoAuth } from '@/components/login/AutoAuth';
import { useGetPatientQuery } from '@/patient-app-common/api/patientApi';
import { getURLParam } from '@/patient-app-common/utils';
import { useAppSelector } from '@/redux/hooks';

export function DirectSurveyAutoAuth() {
  const { token } = useAppSelector(({ auth }) => auth);
  const { search } = useLocation();
  const trackerId = getURLParam(search, 'tracker');

  useGetPatientQuery(undefined, { skip: !token });

  if (!trackerId) {
    return <AutoAuth />;
  }

  return <AutoAuth partialExpiryRedirect={`/recommendation/${trackerId}`} />;
}
